export default __webpack_public_path__ + "static/media/com-prada.260c81b6.mp4";